import React, { useState } from 'react';
import { Button, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

import FlashMessages from '../Common/Messages/FlashMessages';
import Footer from '../Footer/Footer';
import Api from '../../Api';
import { connect } from 'react-redux';
import Header from '../Headers/Header';
import './LoginScreen.scss';
import { hideStatusMsg, onErrorMsg, onWarningMsg } from '../../actions/FlashMessage/FlashMessages';
import { setNavigateToMsg } from '../../actions/Notifications/ScreenReaderInit';
import { setPageTitle } from '../../actions/Page/PageAction';
import { bindActionCreators } from 'redux';
import { Auth } from 'aws-amplify';
import { G_MSG_CHANNEL } from '../../routes/PRoute';

import { Link, useNavigate } from 'react-router-dom';
import { asErrMsgKey, hasAnyError, isEmailValid, isValueValid } from '../Common/Errors/Errors';
import {
  cleanUserToken,
  setLoggedUserDetailsSuccess,
  getUserDetailsFromSession,
  getUserToken,
  sendGADimensions,
} from '../../actions/Users/UserAction';
import { Col, Row } from 'reactstrap';
const SSOURL =
  'https://abl-csu-idp.auth.us-east-1.amazoncognito.com/oauth2/authorize?client_id=2kf34vlgk69ak4atnsqpl5b8uj&response_type=code&scope=email+openid+phone&redirect_uri=http%3A%2F%2Flocalhost%3A3000';
function LoginScreen(props) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isEmailCorrect, setIsEmailCorrect] = useState(true);

  const [disableEmailField, setDisableEmailField] = useState(false);
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSubmit = () => {
    // Handle form submission logic here
    console.log('Email:', email);
    console.log('Password:', password);
  };

  const validateEmail = (email) => {
    // Regular expression for email validation
    console.log('Email ', email);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // Test the email against the regular expression
    const status = emailRegex.test(email);
    setIsEmailCorrect(status);
    return status;
  };
  const emailBlurEvent = (email) => {
    const isEmailOK = validateEmail(email);
    setEmail(email);
    setDisableEmailField(isEmailOK);
    //call SSO enable API here
    //following email are hardcoded till API get ready
    if (['ashaikh@liaisonedu.com', 'rakumar@liaisonedu.com'].includes(email)) {
      window.location = SSOURL;
    }
  };
  const submitLoginForm = async (event) => {
    event.preventDefault();

    const formInputsValidation = {
      username: asErrMsgKey(isEmailValid(email)),
      password: asErrMsgKey(isValueValid(password)),
    };

    // if (this.state.load || hasErrors) {
    //   return;
    // }

    //  this.setState({ load: true, });
    //  this.props.hideStatusMsg();
    //document.getElementById('button-signin-id').focus();
    requestAnimationFrame(() => {
      signInUser();
    });
  };
  const signInUser = async () => {
    const username = email.toLowerCase().trim();
    G_MSG_CHANNEL.postMessage({ action: 'logout', userEmail: username });

    try {
      await Auth.signIn(username, password);
      Api.instance.reset();
      props.getUserToken(); // ?
      const userDetails = await getUserDetailsFromSession();
      props.setLoggedUserDetailsSuccess(userDetails);
      sendGADimensions(userDetails.userPrincipalId);
      //props.history.push(userDetails.userRole === SUPER_USER ? '/users' : '/');
      navigate(userDetails.userRole === SUPER_USER ? '/users' : '/');
    } catch (err) {
      const errMsg = err.message ? err.message : err;
      if (errMsg === 'Password attempts exceeded') {
        props.hideStatusMsg();
        // props.history.push('/accountLocked');
        navigate('/accountLocked');
      } else {
        props.onErrorMsg('Incorrect username or password.', '/login');
      }
      //setState({ load: false });
    }
  };
  return (
    <div className="login-container">
      <Header plainLogo />
      <Grid container justifyContent="center" md={8} alignItems="center">
        <Grid item xs={8} className="login-window-form" md={6}>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            className="login-input"
            disabled={disableEmailField}
            onBlur={(e) => emailBlurEvent(e.target.value)}
            error={!isEmailCorrect}
            inputProps={{ 'data-testid': 'email' }}
          />
          {disableEmailField && (
            <TextField
              label="Password"
              inputProps={{ 'data-testid': 'password' }}
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={handlePasswordChange}
              fullWidth
              className="login-input"
              onBlur={(e) => setPassword(e.target.value)}
            />
          )}
          <Button
            data-testid="signin-button"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            className="login-button mt-4"
            onClickCapture={(e) => submitLoginForm(e)}>
            {disableEmailField ? 'SignIn' : 'Next >>'}
            {/* <CircularProgress color='secondary' size={24} /> */}
          </Button>
          <Row className="mt-2">
            <Col xs={6} className="anchorParent">
              <Link to="/forgotPassword" label="Cancel" className="anchor">
                Forgot your password
              </Link>
            </Col>
            <Col xs={6} className="text-right anchorParent">
              <a
                className="anchor"
                target="_blank"
                rel="noopener noreferrer"
                href="https://help.liaisonedu.com/Analytics">
                Need Help?
              </a>
            </Col>
          </Row>
        </Grid>
      </Grid>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    statusMessage: state.FlashMessages.statusMsg,
    casDetails: state.AppSession.activeCasDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideStatusMsg,
      onErrorMsg,
      onWarningMsg,
      getUserToken,
      setLoggedUserDetailsSuccess,
      cleanUserToken,
      setNavigateToMsg,
      setPageTitle,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(LoginScreen);
